import { render, staticRenderFns } from "./SummaryTransformerInfo.vue?vue&type=template&id=445f2dbf&scoped=true&"
import script from "./SummaryTransformerInfo.vue?vue&type=script&lang=js&"
export * from "./SummaryTransformerInfo.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTransformerInfo.vue?vue&type=style&index=0&id=445f2dbf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f2dbf",
  null
  
)

export default component.exports